import React, { useContext, useEffect, useState } from "react";
import { Context } from "../store/appContext";
import { useNavigate } from "react-router-dom";
import "../styles/forms.css";

const Login = () => {
  const { store, actions } = useContext(Context);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    if (sessionStorage.getItem("session_expired")) {
      sessionStorage.removeItem("session_expired");
      actions.showToast(
        "Sesión expirada. Inicie sesión nuevamente.",
        "warning",
      );
    }
  }, []);

  useEffect(() => {
    if (store.isAuthenticated) {
      const target = store.mustChangePassword
        ? "/change-password"
        : store.role === "scanner"
          ? "/pending-part-exits"
          : "/panel";

      navigate(target, { replace: true });
    }
  }, [store.isAuthenticated, store.mustChangePassword, store.role, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await actions.login(formData.email, formData.password);

    if (!result?.success) {
      actions.showToast("Credenciales inválidas", "error");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h3 className="mb-4 text-center">Iniciar sesión</h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Correo electrónico</label>

            <input
              type="email"
              className="form-control form-control-sm"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Contraseña</label>

            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control form-control-sm"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />

              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary w-100 btn-sm">
            Iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
